import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  default: ({ color = COLORS.BLACK }) => ({
    thRoot: `font-sans inline-flex items-center gap-5 leading-tight text-14 text-black hocus:text-black-active text-${color} hocus:text-${color}-active hocus:underline`,
    thIconWidth: '.7em',
  }),
};
